"use client";

import { motion } from "framer-motion";
import DownloadCTA from "@/components/shared/DownloadCTA";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

export function CTABanner({
  title = "Jetzt kostenlos starten.",
  text = "Lade ncrechner herunter und berechne in wenigen Minuten deine Zulassungschancen für alle deutschen Hochschulen.",
}: {
  title?: string;
  text?: string;
}) {
  return (
    <section className="cv-auto relative bg-accent text-paper overflow-hidden">
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 70% 80% at 50% 0%, rgba(124,58,237,0.38) 0%, rgba(124,58,237,0.12) 42%, transparent 70%)",
        }}
      />
      <motion.div
        variants={stagger(0.09)}
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
        className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-24 flex flex-col items-center text-center gap-6"
      >
        <motion.h2
          variants={fadeUp}
          className="font-display font-bold text-4xl sm:text-5xl tracking-tight leading-[1.1]"
        >
          {title}
        </motion.h2>
        <motion.p variants={fadeUp} className="text-paper/80 text-lg leading-relaxed max-w-xl">
          {text}
        </motion.p>
        <motion.div variants={fadeUp} className="pt-2">
          <DownloadCTA variant="paper" />
        </motion.div>
      </motion.div>
    </section>
  );
}
